import { t } from "i18next";
import SplitButton from "../../components/button/SplitButton";
import { useUpdateTransferIsBookedMutation } from "../../services/bankingService";

import toast from "react-hot-toast";
import { SnackbarSuccess } from "../../components/base/SnackbarAlert/SnackbarSuccess";
import { useToasts } from "../../hooks/useToasts";


export function ChangeTransferIsBookedButton(props) {
    const { onFormErrors, onServerError } = useToasts();
    const { mutate: updateTransferIsBooked, isPending: isUpdatingTransferIsBooked } = useUpdateTransferIsBookedMutation({
            onSuccess: () => {
                toast.custom(
                    () => <SnackbarSuccess message={t("successfullyEdited")} />,
                    {
                        position: "bottom-right",
                    },
                );
                props.onSubmit?.()
            },
            onError: (error) => {
                onServerError(error);
            },
        });


  const handleChangeTransferdIsBooked = (
    value
  ) => {
    if (props.selectedTransfers?.length === 0) return;

    updateTransferIsBooked({transfer_ids: props.selectedTransfers, transfer_is_booked: value})
  };

  const massActions = [
    {
      label: t(`true`),
      callback: () => handleChangeTransferdIsBooked(true),
    },
    {
      label: t(`false`),
      callback: () =>
        handleChangeTransferdIsBooked(false),
    },
  ];

  return (
    <>
      <SplitButton
        label={t("bankings.transferIsBookedButton")}
        withChangeSelectedItem={false}
        color={"success"}
        options={massActions}
      />
    </>
  );
}